module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-regular-rounded-J3WOUERV.woff2?213a21995bbd5d1a3aa9ca1ceb8a70fd";